import { Component, OnInit } from '@angular/core';
import { BirthdayListService } from '../../services/birthday-list.service';
import { PlayroomService } from '../../services/playroom.service';
import { RodjendanskezoneService } from '../../services/rodjendanskezone.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-zakazani-rodjendani-operateri-report',
  templateUrl: './zakazani-rodjendani-operateri-report.component.html',
  styleUrls: ['./zakazani-rodjendani-operateri-report.component.scss'],
})
export class ZakazaniRodjendaniOperateriReportComponent implements OnInit {
  cityQuery = '';
  roomNameQuery = '';
  birthdayZoneNameQuery = '';
  callDateFromQuery = '';
  callDateToQuery = '';
  appointmentDateFromQuery = '';
  appointmentDateToQuery = '';
  employeeIdQuery: number | null = null;

  cities: string[] = [];
  rooms: string[] = [];
  zones: string[] = [];
  operators: any[] = [];

  report: any = { operators: [], totalScheduled: 0 };
  loading = false;

  constructor(
    private birthdayListService: BirthdayListService,
    private playroomService: PlayroomService,
    private birthdayZoneService: RodjendanskezoneService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.loadLookups();
    this.loadSearchResult();
  }

  loadLookups() {
    this.playroomService.getAllPlayroomsSub().subscribe(rooms => {
      this.cities = [...new Set((rooms || []).map(r => r.address).filter(Boolean))];
      this.rooms = [...new Set((rooms || []).map(r => r.roomName).filter(Boolean))];
    });

    this.birthdayZoneService
      .getAllPlayroomZonesSub({ currentPage: 1, itemsPerPage: 2147483647 })
      .subscribe(zones => {
        this.zones = [...new Set((zones || []).map(z => z.zoneName).filter(Boolean))];
      });

    this.userService
      .getAllUsersSub({ currentPage: 1, itemsPerPage: 2147483647 })
      .subscribe(users => {
        this.operators = (users || []).filter(
          (u: any) => u.role === 'Operater' || u.role === 'Employee'
        );
      });
  }

  loadSearchResult() {
    this.loading = true;
    this.birthdayListService
      .getScheduledByOperatorReport({
        cityQuery: this.cityQuery,
        roomNameQuery: this.roomNameQuery,
        birthdayZoneNameQuery: this.birthdayZoneNameQuery,
        callDateFromQuery: this.callDateFromQuery,
        callDateToQuery: this.callDateToQuery,
        appointmentDateFromQuery: this.appointmentDateFromQuery,
        appointmentDateToQuery: this.appointmentDateToQuery,
        employeeIdQuery: this.employeeIdQuery
      })
      .subscribe(res => {
        const reportBody = res?.body ?? { operators: [], totalScheduled: 0 };
        this.report = {
          ...reportBody,
          operators: (reportBody.operators || []).map(group => ({
            ...group,
            birthdays: (group.birthdays || []).slice().sort((a, b) => {
              const aTime = new Date(a?.callDate || 0).getTime();
              const bTime = new Date(b?.callDate || 0).getTime();
              return bTime - aTime;
            })
          }))
        };
        this.loading = false;
      });
  }

  resetFilters() {
    this.cityQuery = '';
    this.roomNameQuery = '';
    this.birthdayZoneNameQuery = '';
    this.callDateFromQuery = '';
    this.callDateToQuery = '';
    this.appointmentDateFromQuery = '';
    this.appointmentDateToQuery = '';
    this.employeeIdQuery = null;
    this.loadSearchResult();
  }

  exportCsv() {
    const csvRows: string[] = [];

    csvRows.push([
      'Operater',
      'Posetilac',
      'Grad',
      'Objekat',
      'Rodjendanska zona',
      'Datum primljenog poziva',
      'Datum zakazanog rođendana'
    ].map(value => this.escapeCsv(value)).join(','));

    for (const group of this.report?.operators || []) {
      const operatorFullName = `${group.operatorFirstName || ''} ${group.operatorLastName || ''}`.trim();

      for (const birthday of group.birthdays || []) {
        csvRows.push([
          operatorFullName,
          birthday.visitorFullName || '',
          birthday.city || '',
          birthday.roomName || '',
          birthday.birthdayZoneName || '',
          this.formatDate(birthday.callDate),
          this.formatDate(birthday.appointmentDate)
        ].map(value => this.escapeCsv(value)).join(','));
      }

      csvRows.push([
        operatorFullName,
        'Zbir po operateru',
        '',
        '',
        '',
        '',
        String(group.totalScheduled ?? 0)
      ].map(value => this.escapeCsv(value)).join(','));
    }

    csvRows.push([
      'UKUPNO',
      'Ukupan zbir zakazanih rođendana',
      '',
      '',
      '',
      '',
      String(this.report?.totalScheduled ?? 0)
    ].map(value => this.escapeCsv(value)).join(','));

    const csvContent = '\uFEFF' + csvRows.join('\n');
    this.blobToFile(csvContent, 'text/csv;charset=utf-8;', 'ZakazaniRodjendaniPoOperateru.csv');
  }

  private escapeCsv(value: string): string {
    return `"${String(value ?? '').replace(/"/g, '""')}"`;
  }

  private formatDate(value: string | Date): string {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}.${month}.${year}.`;
  }

  blobToFile(data: any, type: string, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
}
